import { render, staticRenderFns } from "./Blockly.vue?vue&type=template&id=656ed32a&scoped=true&"
import script from "./Blockly.vue?vue&type=script&lang=js&"
export * from "./Blockly.vue?vue&type=script&lang=js&"
import style0 from "./Blockly.vue?vue&type=style&index=0&id=656ed32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ed32a",
  null
  
)

export default component.exports